import api from "../api";

export default {
    show() {
        return api.get('/merchant/account')
    },

    patch(data) {
        return api.patch('/merchant/account', data)
    },

    acceptLegal() {
        return api.patch('/merchant/account/acceptLegal')
    }
}